export default {
  AUTHENTICATION_REQUIRED: 'AUTHENTICATION_REQUIRED',
  HTTP_SESSION_EXPIRED: 'HTTP_SESSION_EXPIRED',
  HTTP_SESSION_REFRESH_TOKEN_FAILED: 'HTTP_SESSION_REFRESH_TOKEN_FAILED',
  SUBSCRIBER_TERMS_NOT_ACCEPTED: 'SUBSCRIBER_TERMS_NOT_ACCEPTED',
};
